




























































import {Vue, Component, Prop} from 'vue-property-decorator'
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import QInput, {Loading} from 'quasar';
import ITodoCollection, {ITodo} from '@/models/todoCollection';
import { mapGetters } from "vuex";
import firebase from 'firebase';
import DocumentModule from '@/store/application/DocumentModule';
import HomeViewModule from '@/store/view/HomeViewModule';

@Component
export default class Notecards extends Vue {
	public currentCard: number = 0;
	public toggleCard: boolean = true;
	public selected: string[] = [];

	public get tasks(): ITodo[] {
		return DocumentModule.tasks;
	}
	
	public get document(): ITodoCollection {
		return DocumentModule.document;
	}

	public get user() {
		return this.$store.getters.user;
	}

	public get title() {
		if (this.tasks[this.currentCard].title) {
			return this.tasks[this.currentCard].title;
		} else {
			return ''
		}
	}

	public get body() {
		if (this.tasks[this.currentCard].body) {
			return this.tasks[this.currentCard].body;
		} else {
			return 'Error.'
		}
	}

	public getSelectedString() {
      	return this.selected.length === 0 ? '' : `${this.selected.length} record${this.selected.length > 1 ? 's' : ''} selected of ${this.tasks.length}`
	}
	
	public toggleCardPosition(event: Event) {
		if (this.toggleCard == true) {
			this.toggleCard = false;
		} else {
			this.toggleCard = true;
		}
	}

	public wrong(element: any) {
		this.tasks.splice(this.tasks.indexOf(element), 1);
		this.tasks.splice(this.tasks.indexOf(element) + (this.tasks.length/2), 0, element);
		this.toggleCard = true;
	}

	public partiallyCorrect(element: any) {
		this.tasks.splice(this.tasks.indexOf(element), 1);
		this.tasks.splice(this.tasks.indexOf(element) + (this.tasks.length/1.5), 0, element);
		this.toggleCard = true;
	}

	public correct(element: any) {
		this.tasks.push(this.tasks.splice(this.tasks.indexOf(element), 1)[0]);
		this.toggleCard = true;
	}

	beforeCreate() {
        firebase.auth().onAuthStateChanged(async () => {
			Loading.show();
            await HomeViewModule.loadDocuments(this.$store.getters.user);
			await DocumentModule.loadDocument(this.$route.params.id);
			Loading.hide();
        })
    }
}

